import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Skills`}</h2>
    <h4>{`Programming Languages`}</h4>
    <ul>
      <li parentName="ul">{`Html.`}</li>
      <li parentName="ul">{`CSS.`}</li>
      <li parentName="ul">{`Javascript, Typescript.`}</li>
      <li parentName="ul">{`Php.`}</li>
      <li parentName="ul">{`Python.`}</li>
    </ul>
    <h4>{`Technologies, Frameworks`}</h4>
    <ul>
      <li parentName="ul">{`Front end: React, React Hooks, Redux, Mobx, jQuery, Sass, Bootstrap.`}</li>
      <li parentName="ul">{`Mobile: React Native, Android Studio, Xcode`}</li>
      <li parentName="ul">{`Back end: Symphony, NodeJs, API Platform, Firebase, Mailgun.`}</li>
      <li parentName="ul">{`Web Services: REST, SOAP, GraphQL (JSON/WSDL/XML).`}</li>
      <li parentName="ul">{`Database and persistence frameworks: Doctrine, MySql, MariaDB, PostgreSQL.`}</li>
      <li parentName="ul">{`CI/CD: Git, Github, CircleCi, Github Actions.`}</li>
      <li parentName="ul">{`Testing: Jest, React Test Renderer, PhpUnit, Codeception, Cypress, Selenium.`}</li>
      <li parentName="ul">{`Observability: Rollbar.`}</li>
      <li parentName="ul">{`Build: Babel, Webpack, Docker, Fastlane, Gradle,`}</li>
      <li parentName="ul">{`Deploy: Google Cloud Platform.`}</li>
    </ul>
    <h4>{`Tools`}</h4>
    <ul>
      <li parentName="ul">{`IDE & Editors: VSCode, PhpStorm, Webstorm, PyCharm.`}</li>
      <li parentName="ul">{`Clients: HeidiSQL, MobaXterm.`}</li>
      <li parentName="ul">{`Agile: Jira, Slack, Microsoft Teams.`}</li>
    </ul>
    <h4>{`Agile and Soft Skills`}</h4>
    <ul>
      <li parentName="ul">{`Excellent technical and non-technical communication skills.`}</li>
      <li parentName="ul">{`Ability to work independently and integrate within a team environment.`}</li>
      <li parentName="ul">{`Experience working in an Agile Software Development environment`}</li>
      <li parentName="ul">{`Experience with remote work, and online code pairing`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      